import React, { useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";
import { updateHomeProfileDetails } from "../../../HttpRequest/afterlogin";
import defaultImage from "../../../../assets/img/profiles/icons8-test-account-90.png";

const StudentProfileView = ({ profileData, userProfileUrl, onUpdateProfile, onPhotoUpload }) => {
  const fileInputRef = useRef(null);
  const [activeTab, setActiveTab] = useState("overview");
  const [isEditing, setIsEditing] = useState(false);
  const [saving, setSaving] = useState(false);

  const [formData, setFormData] = useState({
    id: profileData?.id || "",
    firstName: profileData?.firstName || "",
    lastName: profileData?.lastName || "",
    email: profileData?.email || "",
    phoneNumber: profileData?.phoneNumber || profileData?.mobileNumber || "",
    whatsappNumber: profileData?.whatsappNumber || "",
    dateOfBirth: profileData?.dateOfBirth || profileData?.dob || "",
    gender: profileData?.gender || "",
    nationality: profileData?.nationality || "",
    passportNumber: profileData?.passportNumber || profileData?.profileDetails?.passportNumber || "",
    passportExpiry: profileData?.passportExpiry || profileData?.profileDetails?.passportExpiry || "",

    highestDegree: profileData?.highestDegree || profileData?.educationDetails?.highestQualification || profileData?.educationDetails?.degree || "",
    collegeName: profileData?.yourCollageName || profileData?.collegeName || profileData?.educationDetails?.institution || "",
    gpa: profileData?.gpa || profileData?.educationDetails?.gpa || profileData?.educationDetails?.percentage || "",
    graduationYear: profileData?.graduationYear || profileData?.educationDetails?.passingYear || "",
    targetDegree: profileData?.targetDegree || profileData?.profileDetails?.desiredCourse || "",
    targetCountry: profileData?.targetCountry || profileData?.profileDetails?.countryPreference || "",
    targetIntake: profileData?.targetIntake || profileData?.profileDetails?.intakeYear || "",

    greScore: profileData?.greScore || profileData?.testScores?.greScore || "",
    ieltsScore: profileData?.ieltsScore || profileData?.testScores?.ieltsScore || "",
    toeflScore: profileData?.toeflScore || profileData?.testScores?.toeflScore || "",

    address: profileData?.address || "",
    city: profileData?.city || "",
    country: profileData?.country || "",
    zipCode: profileData?.zipCode || profileData?.postalCode || ""
  });

  useEffect(() => {
    if (profileData) {
      setFormData({
        id: profileData?.id || "",
        firstName: profileData?.firstName || "",
        lastName: profileData?.lastName || "",
        email: profileData?.email || "",
        phoneNumber: profileData?.phoneNumber || profileData?.mobileNumber || "",
        whatsappNumber: profileData?.whatsappNumber || "",
        dateOfBirth: profileData?.dateOfBirth || profileData?.dob || "",
        gender: profileData?.gender || "",
        nationality: profileData?.nationality || "",
        passportNumber: profileData?.passportNumber || profileData?.profileDetails?.passportNumber || "",
        passportExpiry: profileData?.passportExpiry || profileData?.profileDetails?.passportExpiry || "",

        highestDegree: profileData?.highestDegree || profileData?.educationDetails?.highestQualification || profileData?.educationDetails?.degree || "",
        collegeName: profileData?.yourCollageName || profileData?.collegeName || profileData?.educationDetails?.institution || "",
        gpa: profileData?.gpa || profileData?.educationDetails?.gpa || profileData?.educationDetails?.percentage || "",
        graduationYear: profileData?.graduationYear || profileData?.educationDetails?.passingYear || "",
        targetDegree: profileData?.targetDegree || profileData?.profileDetails?.desiredCourse || "",
        targetCountry: profileData?.targetCountry || profileData?.profileDetails?.countryPreference || "",
        targetIntake: profileData?.targetIntake || profileData?.profileDetails?.intakeYear || "",

        greScore: profileData?.greScore || profileData?.testScores?.greScore || "",
        ieltsScore: profileData?.ieltsScore || profileData?.testScores?.ieltsScore || "",
        toeflScore: profileData?.toeflScore || profileData?.testScores?.toeflScore || "",

        address: profileData?.address || "",
        city: profileData?.city || "",
        country: profileData?.country || "",
        zipCode: profileData?.zipCode || profileData?.postalCode || ""
      });
    }
  }, [profileData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      if (formData.id) {
        await updateHomeProfileDetails(formData);
      }
      setIsEditing(false);
      if (onUpdateProfile) {
        onUpdateProfile(formData);
      }
      Swal.fire({
        icon: "success",
        title: "Profile Saved!",
        text: "Your profile information has been successfully saved.",
        timer: 2000,
        showConfirmButton: false
      });
    } catch (error) {
      console.error("Error updating profile:", error);
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: "Could not save profile details."
      });
    } finally {
      setSaving(false);
    }
  };

  const val = (v) => (v && String(v).trim() !== "" ? v : "-");

  const fieldsToCheck = [
    formData.firstName,
    formData.email,
    formData.phoneNumber,
    formData.dateOfBirth,
    formData.passportNumber,
    formData.highestDegree,
    formData.collegeName,
    formData.targetDegree,
    formData.city
  ];
  const filledCount = fieldsToCheck.filter(v => v && String(v).trim() !== "").length;
  const completionPercentage = Math.round((filledCount / fieldsToCheck.length) * 100);

  return (
    <div className="student-profile-container">
      {/* Student Profile Hero Header */}
      <div className="student-header-card">
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
          <div className="d-flex align-items-center gap-4 flex-wrap">
            <div
              className="profile-avatar-wrapper"
              style={{ cursor: "pointer" }}
              onClick={() => fileInputRef.current?.click()}
              title="Click to change profile picture"
            >
              <img
                src={userProfileUrl || defaultImage}
                alt="Student Avatar"
                className="profile-avatar-img-large"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = defaultImage;
                }}
              />
              <div className="avatar-edit-overlay" title="Click to upload profile photo">
                <i className="fas fa-camera"></i>
              </div>
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                accept="image/png, image/jpeg, image/jpg, image/webp"
                onChange={onPhotoUpload}
              />
            </div>
            <div>
              <div className="d-flex align-items-center gap-2 mb-1">
                <span className="badge-role badge-student">
                  <i className="fas fa-user-graduate"></i> Student Profile
                </span>
                <span className="badge-status-active">
                  <i className="fas fa-check-circle"></i> Account Verified
                </span>
              </div>
              <h2 className="m-0 text-white font-weight-bold">
                {formData.firstName || formData.lastName ? `${formData.firstName} ${formData.lastName}`.trim() : (formData.email || "Student")}
              </h2>
              {formData.targetDegree ? (
                <p className="text-light opacity-75 mb-1 mt-1" style={{ fontSize: "0.95rem" }}>
                  <i className="fas fa-graduation-cap me-1 text-warning"></i> {formData.targetDegree} {formData.targetCountry ? `• ${formData.targetCountry}` : ""}
                </p>
              ) : formData.email ? (
                <p className="text-light opacity-75 mb-1 mt-1" style={{ fontSize: "0.95rem" }}>
                  <i className="fas fa-envelope me-1 text-warning"></i> {formData.email}
                </p>
              ) : null}
              <p className="text-light opacity-60 m-0" style={{ fontSize: "0.85rem" }}>
                Student ID: <span className="fw-bold">{formData.id ? `STU-${formData.id}` : "-"}</span> {formData.targetIntake ? `• Intake: ${formData.targetIntake}` : ""}
              </p>
            </div>
          </div>

          <div className="d-flex flex-column align-items-end gap-2">
            {!isEditing ? (
              <button
                className="btn btn-light btn-sm fw-bold px-3 py-2 rounded-pill shadow-sm"
                onClick={() => setIsEditing(true)}
              >
                <i className="fas fa-edit me-1"></i> Edit Profile
              </button>
            ) : (
              <button
                className="btn btn-outline-light btn-sm fw-bold px-3 py-2 rounded-pill"
                onClick={() => setIsEditing(false)}
              >
                <i className="fas fa-times me-1"></i> Cancel
              </button>
            )}
          </div>
        </div>

        {/* Completion Progress Bar */}
        <div className="completion-container">
          <div className="d-flex justify-content-between align-items-center text-white font-weight-600 mb-1" style={{ fontSize: "0.85rem" }}>
            <span>Profile Completion Status</span>
            <span>{completionPercentage}% Completed</span>
          </div>
          <div className="completion-bar-bg">
            <div className="completion-bar-fill" style={{ width: `${completionPercentage}%` }}></div>
          </div>
        </div>
      </div>

      {/* Profile Navigation Tabs */}
      <div className="role-nav-tabs">
        <button
          className={`role-tab-btn ${activeTab === "overview" ? "active" : ""}`}
          onClick={() => setActiveTab("overview")}
        >
          <i className="fas fa-chart-pie me-2"></i> Overview
        </button>
        <button
          className={`role-tab-btn ${activeTab === "personal" ? "active" : ""}`}
          onClick={() => setActiveTab("personal")}
        >
          <i className="fas fa-user me-2"></i> Personal Info
        </button>
        <button
          className={`role-tab-btn ${activeTab === "academic" ? "active" : ""}`}
          onClick={() => setActiveTab("academic")}
        >
          <i className="fas fa-graduation-cap me-2"></i> Academics & Scores
        </button>
        <button
          className={`role-tab-btn ${activeTab === "contact" ? "active" : ""}`}
          onClick={() => setActiveTab("contact")}
        >
          <i className="fas fa-address-book me-2"></i> Contact & Address
        </button>
      </div>

      {/* Tab Contents */}
      {!isEditing ? (
        <div>
          {activeTab === "overview" && (
            <div className="row">
              <div className="col-lg-8">
                <div className="role-card">
                  <div className="role-card-header">
                    <h4 className="role-card-title">
                      <i className="fas fa-compass"></i> Study Abroad Goals
                    </h4>
                  </div>
                  <div className="info-grid mb-4">
                    <div className="info-item">
                      <div className="info-label">Target Program</div>
                      <div className="info-value">{val(formData.targetDegree)}</div>
                    </div>
                    <div className="info-item">
                      <div className="info-label">Target Destination</div>
                      <div className="info-value">{val(formData.targetCountry)}</div>
                    </div>
                    <div className="info-item">
                      <div className="info-label">Intake Season</div>
                      <div className="info-value">{val(formData.targetIntake)}</div>
                    </div>
                    <div className="info-item">
                      <div className="info-label">Current Qualification</div>
                      <div className="info-value">{val(formData.highestDegree)}</div>
                    </div>
                  </div>

                  <h5 className="fw-bold mb-3" style={{ fontSize: "1rem", color: "#FFE082" }}>
                    <i className="fas fa-tasks me-2" style={{ color: "#D4AF37" }}></i> Profile Completion Checklist
                  </h5>
                  <div className="d-flex flex-column gap-2">
                    <div className="info-item d-flex align-items-center justify-content-between">
                      <span className="fw-bold d-flex align-items-center">
                        <i className={`fas ${formData.firstName && formData.email ? "fa-check-circle text-success" : "fa-circle-notch text-muted"} me-2`}></i> Personal & Contact Details
                      </span>
                      <span className={`checklist-badge ${formData.firstName && formData.email ? "completed" : "incomplete"}`}>
                        {formData.firstName && formData.email ? "Completed" : "Incomplete"}
                      </span>
                    </div>
                    <div className="info-item d-flex align-items-center justify-content-between">
                      <span className="fw-bold d-flex align-items-center">
                        <i className={`fas ${formData.collegeName || formData.highestDegree ? "fa-check-circle text-success" : "fa-circle-notch text-muted"} me-2`}></i> Academic Information
                      </span>
                      <span className={`checklist-badge ${formData.collegeName || formData.highestDegree ? "completed" : "incomplete"}`}>
                        {formData.collegeName || formData.highestDegree ? "Provided" : "Incomplete"}
                      </span>
                    </div>
                    <div className="info-item d-flex align-items-center justify-content-between">
                      <span className="fw-bold d-flex align-items-center">
                        <i className={`fas ${formData.greScore || formData.ieltsScore || formData.toeflScore ? "fa-check-circle text-success" : "fa-circle-notch text-muted"} me-2`}></i> Test Scores
                      </span>
                      <span className={`checklist-badge ${formData.greScore || formData.ieltsScore || formData.toeflScore ? "completed" : "pending"}`}>
                        {formData.greScore || formData.ieltsScore || formData.toeflScore ? "Provided" : "Pending"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="role-card">
                  <div className="role-card-header">
                    <h4 className="role-card-title">
                      <i className="fas fa-bolt"></i> Quick Summary
                    </h4>
                  </div>
                  <div className="d-flex flex-column gap-3">
                    <div className="info-item d-flex align-items-center gap-3">
                      <div className="text-warning fs-3" style={{ width: "32px", textAlign: "center" }}>
                        <i className="fas fa-university"></i>
                      </div>
                      <div>
                        <div className="text-muted small fw-bold">COLLEGE</div>
                        <div className="fs-6 fw-bold text-white">{val(formData.collegeName)}</div>
                      </div>
                    </div>

                    <div className="info-item d-flex align-items-center gap-3">
                      <div className="text-success fs-3" style={{ width: "32px", textAlign: "center" }}>
                        <i className="fas fa-passport"></i>
                      </div>
                      <div>
                        <div className="text-muted small fw-bold">PASSPORT</div>
                        <div className="fs-6 fw-bold text-white">{val(formData.passportNumber)}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === "personal" && (
            <div className="role-card">
              <div className="role-card-header">
                <h4 className="role-card-title">
                  <i className="fas fa-user"></i> Personal Identity Details
                </h4>
              </div>
              <div className="info-grid">
                <div className="info-item">
                  <div className="info-label">First Name</div>
                  <div className="info-value">{val(formData.firstName)}</div>
                </div>
                <div className="info-item">
                  <div className="info-label">Last Name</div>
                  <div className="info-value">{val(formData.lastName)}</div>
                </div>
                <div className="info-item">
                  <div className="info-label">Date of Birth</div>
                  <div className="info-value">{val(formData.dateOfBirth)}</div>
                </div>
                <div className="info-item">
                  <div className="info-label">Gender</div>
                  <div className="info-value">{val(formData.gender)}</div>
                </div>
                <div className="info-item">
                  <div className="info-label">Nationality</div>
                  <div className="info-value">{val(formData.nationality)}</div>
                </div>
                <div className="info-item">
                  <div className="info-label">Passport Number</div>
                  <div className="info-value">{val(formData.passportNumber)}</div>
                </div>
                <div className="info-item">
                  <div className="info-label">Passport Expiry</div>
                  <div className="info-value">{val(formData.passportExpiry)}</div>
                </div>
              </div>
            </div>
          )}

          {activeTab === "academic" && (
            <div className="role-card">
              <div className="role-card-header">
                <h4 className="role-card-title">
                  <i className="fas fa-graduation-cap"></i> Academic History & Test Scores
                </h4>
              </div>
              <div className="info-grid mb-4">
                <div className="info-item">
                  <div className="info-label">Highest Qualification</div>
                  <div className="info-value">{val(formData.highestDegree)}</div>
                </div>
                <div className="info-item">
                  <div className="info-label">College / Institution</div>
                  <div className="info-value">{val(formData.collegeName)}</div>
                </div>
                <div className="info-item">
                  <div className="info-label">GPA / Percentage</div>
                  <div className="info-value">{val(formData.gpa)}</div>
                </div>
                <div className="info-item">
                  <div className="info-label">Graduation Year</div>
                  <div className="info-value">{val(formData.graduationYear)}</div>
                </div>
              </div>

              <h5 className="fw-bold mb-3" style={{ fontSize: "1rem", color: "#FFE082" }}>
                <i className="fas fa-award me-2" style={{ color: "#D4AF37" }}></i> Standardized Test Scores
              </h5>
              <div className="info-grid">
                <div className="info-item">
                  <div className="info-label">GRE Score</div>
                  <div className="info-value">{val(formData.greScore)}</div>
                </div>
                <div className="info-item">
                  <div className="info-label">IELTS Score</div>
                  <div className="info-value">{val(formData.ieltsScore)}</div>
                </div>
                <div className="info-item">
                  <div className="info-label">TOEFL Score</div>
                  <div className="info-value">{val(formData.toeflScore)}</div>
                </div>
              </div>
            </div>
          )}

          {activeTab === "contact" && (
            <div className="role-card">
              <div className="role-card-header">
                <h4 className="role-card-title">
                  <i className="fas fa-address-book"></i> Contact & Address Information
                </h4>
              </div>
              <div className="info-grid mb-4">
                <div className="info-item">
                  <div className="info-label">Email Address</div>
                  <div className="info-value">{val(formData.email)}</div>
                </div>
                <div className="info-item">
                  <div className="info-label">Mobile Phone</div>
                  <div className="info-value">{val(formData.phoneNumber)}</div>
                </div>
                <div className="info-item">
                  <div className="info-label">WhatsApp Number</div>
                  <div className="info-value">{val(formData.whatsappNumber)}</div>
                </div>
              </div>
              <div className="info-grid">
                <div className="info-item">
                  <div className="info-label">Street Address</div>
                  <div className="info-value">{val(formData.address)}</div>
                </div>
                <div className="info-item">
                  <div className="info-label">City</div>
                  <div className="info-value">{val(formData.city)}</div>
                </div>
                <div className="info-item">
                  <div className="info-label">Country</div>
                  <div className="info-value">{val(formData.country)}</div>
                </div>
                <div className="info-item">
                  <div className="info-label">Postal / Zip Code</div>
                  <div className="info-value">{val(formData.zipCode)}</div>
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        /* EDIT MODE FORM */
        <form onSubmit={handleSave} className="role-card">
          <div className="role-card-header">
            <h4 className="role-card-title">
              <i className="fas fa-edit"></i> Edit Student Profile Information
            </h4>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="profile-input-group">
                <label className="profile-label">First Name</label>
                <input
                  type="text"
                  name="firstName"
                  className="profile-input"
                  value={formData.firstName}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="profile-input-group">
                <label className="profile-label">Last Name</label>
                <input
                  type="text"
                  name="lastName"
                  className="profile-input"
                  value={formData.lastName}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="profile-input-group">
                <label className="profile-label">Email Address</label>
                <input
                  type="email"
                  name="email"
                  className="profile-input"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="profile-input-group">
                <label className="profile-label">Phone Number</label>
                <input
                  type="text"
                  name="phoneNumber"
                  className="profile-input"
                  value={formData.phoneNumber}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="profile-input-group">
                <label className="profile-label">Target Program</label>
                <input
                  type="text"
                  name="targetDegree"
                  className="profile-input"
                  value={formData.targetDegree}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="profile-input-group">
                <label className="profile-label">Target Destination Country</label>
                <input
                  type="text"
                  name="targetCountry"
                  className="profile-input"
                  value={formData.targetCountry}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="profile-input-group">
                <label className="profile-label">College / University Name</label>
                <input
                  type="text"
                  name="collegeName"
                  className="profile-input"
                  value={formData.collegeName}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="profile-input-group">
                <label className="profile-label">City</label>
                <input
                  type="text"
                  name="city"
                  className="profile-input"
                  value={formData.city}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end gap-2 mt-4 pt-3 border-top border-secondary">
            <button
              type="button"
              className="btn-role-secondary"
              onClick={() => setIsEditing(false)}
              disabled={saving}
            >
              Cancel
            </button>
            <button type="submit" className="btn-role-primary" disabled={saving}>
              {saving ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default StudentProfileView;
